import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { ESTADOS_ORDEN_PRODUCCION } from "../../../../../../../../../../utility/constants";
import { DecisionSwal } from "../../../../../../../../Utils/Utils/DecisionSwal";
const playIcon = require("assets/img/icons/play-icon.png");
const stopIcon = require("assets/img/icons/stop.png");
const verIcon = require("assets/img/icons/ver.png");

export const TblActionsContent = ({
    item,
    IniciarOrdenProduccion,
    CompletarOrdenProduccion,
}) => {
    const MostrarMensajeCompletarProduccion = (item) => {
        let mensaje =
            "¿Está seguro que desea completar esta orden de producción con el estado actual? Esta acción no se podrá revertir.";

        DecisionSwal(mensaje, "Sí", "No", () =>
            CompletarOrdenProduccion(item && item.id ? item.id : null),
        );
    };

    const estado = item && item.estado ? item.estado : null;

    if (estado === ESTADOS_ORDEN_PRODUCCION.PENDIENTE) {
        return (
            <div className="table-actions">
                <img
                    src={playIcon}
                    alt="Iniciar producción"
                    className="action_img"
                    title="Iniciar producción"
                    onClick={() => {
                        IniciarOrdenProduccion(item);
                    }}
                />
            </div>
        );
    } else if (estado === ESTADOS_ORDEN_PRODUCCION.EN_PROCESO) {
        return (
            <div className="table-actions">
                <img
                    src={playIcon}
                    alt="Continuar producción"
                    className="action_img"
                    title="Continuar producción"
                    onClick={() => {
                        IniciarOrdenProduccion(item);
                    }}
                />
                <img
                    src={stopIcon}
                    alt="Completar producción"
                    className="action_img"
                    title="Completar producción"
                    onClick={() => MostrarMensajeCompletarProduccion(item)}
                    style={{ width: "26px", height: "26px" }}
                />
            </div>
        );
    } else if (estado === ESTADOS_ORDEN_PRODUCCION.COMPLETADO) {
        return (
            <Link to={`/produccion-v2/detalle-tancadas/${item.id}`}>
                <div className="table-actions">
                    <img
                        src={verIcon}
                        alt="Ver"
                        className="action_img"
                        title="Ver"
                    />
                </div>
            </Link>
        );
    } else {
        return null;
    }
};
